import styled from "styled-components";
import background from "../assets/login.webp";

export default function PendingApproval() {
  return (
    <Container>
      <Card>
        <Icon>⏳</Icon>
        <Title>Account Created</Title>
        <Subtitle>Pending Approval</Subtitle>

        <Text>
          Your account is currently under review.
          <br />
          You will be notified once approved.
        </Text>
      </Card>
    </Container>
  );
}

const Container = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background: url(${background}) center/cover no-repeat;
`;

const Card = styled.div`
  background: rgba(255,255,255,0.08);
  backdrop-filter: blur(12px);
  padding: 2.5rem;
  border-radius: 20px;
  text-align: center;
  color: white;
`;

const Icon = styled.div`
  font-size: 3rem;
`;

const Title = styled.h2`
  margin-top: 1rem;
`;

const Subtitle = styled.h3`
  color: #ffd369;
`;

const Text = styled.p`
  margin-top: 1rem;
  color: #ccc;
`;
